// eslint-disable-next-line import/prefer-default-export
export const SERVER_URL = "https://social-lair-api.bit.learnistic.com";
export const AUTH_URL = "https://auth-api.bit.learnistic.com";
// export const SERVER_URL = "http://192.168.0.102:6980";
export const BUCKET_URL = "https://bucket.bit.learnistic.com";
